import React, { useState } from "react";

const CaseSummary = ({ caseSummary }) => {
  const [isOpen, setIsOpen] = useState(true);
  if (!caseSummary) return ''


  // helper function to convert snake_case -> Title Case
  const formatTitle = (text) => {
    return text
      .replace(/_/g, " ")
      .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
  };

  return (
    <div className="mt-2" style={ { marginRight: "1.5%" } }>
      <h4>
        <button
          className="btn btn-link text-decoration-none d-flex align-items-center"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#caseSummaryCollapse"
          aria-expanded={ isOpen }
          aria-controls="caseSummaryCollapse"
          onClick={ () => setIsOpen(!isOpen) }
        >
          <span className={ `me-2 bi ${isOpen ? "bi-caret-down-fill" : "bi-caret-right-fill"}` }></span>
          Case Summary
        </button>
      </h4>

      <div className="collapse show" id="caseSummaryCollapse">
        <table className="table table-bordered table-striped">
          <thead className="table-primary">
            <tr>
              <th>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            { Object.entries(caseSummary).map(([key, value]) => (
              <tr key={ key }>
                <td>{ formatTitle(key) }</td>
                <td>{ value }</td>
              </tr>
            )) }
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CaseSummary;
